import api from '../../../core/api/client';

const BASE    = '/project-promotions';
const byId    = (id) => `${BASE}/${encodeURIComponent(id)}`;
const sub     = (id, path) => `${byId(id)}/${path}`;

const toApiError = (error) => {
  if (error?.response) {
    const d = error.response.data;
    return {
      status:  error.response.status,
      message: d?.detail || d?.message || d?.error || error.message || 'Request failed',
      data:    d,
    };
  }
  return { status: 0, message: error?.message || 'Unexpected error', data: null };
};

const wrap = async (fn) => {
  try { return await fn(); }
  catch (error) { throw toApiError(error); }
};

export const projectPromotionsService = {
  async list({ projectId, status, ownerId } = {}) {
    return wrap(async () => {
      const params = {};
      if (projectId) params.projectId = projectId;
      if (status)    params.status    = status;     // array[string] OK
      if (ownerId)   params.ownerId   = ownerId;
      const res = await api.get(BASE, { params });
      return res.data;
    });
  },

  async create(data) {
    return wrap(async () => {
      const res = await api.post(BASE, data);
      return res.data;
    });
  },

  async listForProject(projectId) {
    return wrap(async () => {
      const res = await api.get(`/projects/${encodeURIComponent(projectId)}/promotions`);
      return res.data;
    });
  },

  async get(promotionId) {
    return wrap(async () => {
      const res = await api.get(byId(promotionId));
      return res.data;
    });
  },

  async update(promotionId, patch) {
    return wrap(async () => {
      const res = await api.patch(byId(promotionId), patch);
      return res.data;
    });
  },

  async delete(promotionId) {
    return wrap(async () => {
      const res = await api.delete(byId(promotionId));
      return res.data;
    });
  },

  async attachContent(promotionId, ids) {
    return wrap(async () => {
      const res = await api.post(sub(promotionId, 'content'), { ids });
      return res.data;
    });
  },

  async detachContent(promotionId, ids) {
    return wrap(async () => {
      const res = await api.delete(sub(promotionId, 'content'), { data: { ids } });
      return res.data;
    });
  },

  async attachAssetRequests(promotionId, ids) {
    return wrap(async () => {
      const res = await api.post(sub(promotionId, 'asset-requests'), { ids });
      return res.data;
    });
  },

  async detachAssetRequests(promotionId, ids) {
    return wrap(async () => {
      const res = await api.delete(sub(promotionId, 'asset-requests'), { data: { ids } });
      return res.data;
    });
  },

  async getMetrics(promotionId) {
    return wrap(async () => {
      const res = await api.get(sub(promotionId, 'metrics'));
      return res.data;
    });
  },
};

export const PROMOTION_STATUSES = ['planning', 'active', 'paused', 'completed', 'cancelled'];

export const COMMON_CHANNELS = [
  'instagram', 'facebook', 'twitter', 'linkedin',
  'youtube', 'tiktok', 'email', 'whatsapp', 'website',
];
